<template>
  <div>
    <div class="main" style="margin-top: 5px;">
      <div class="n-left-nav" style="width: 200px;">
        <div class="navTitle">
          交易项目
        </div>
        <div class="m-nav-list" style="width: 160px;">
          <router-link :to="{ name: 'transferList' }" class="typeNav">
            <div class="typeNav activeSelectType">转让项目</div>
          </router-link>

          <router-link :to="{ name: 'demandList' }" class="typeNav">
            <div class="typeNav ">需求项目</div>
          </router-link>
          <router-link :to="{ name: 'procureList' }" class="typeNav">
            <div class="typeNav ">采购项目</div>
          </router-link>
          <router-link :to="{ name: 'doneDealList' }">
            <div class="typeNav">成交公告</div>
          </router-link>
          <router-link :to="{ name: 'verifyList' }">
            <div class="typeNav">鉴证公示</div>
          </router-link>
        </div>
      </div>
      <div class="page-right" style="width: 980px;border: 1px solid #e4e4e4;margin-top: 20px;margin-right: 20px">
        <div class="pagelujing">
          <div class="name" style="padding-left: 5px;"><a href="#">转让项目</a>&nbsp; </div>

          <div style="width:400px;float:right;text-align: right;">
            <input type="text" style="height: 35px;width: 200px;" placeholder="请输入关键字查询" v-model="itemName" />
            <button class="btn-search1" @click="getDatas()">查询</button>

          </div>

        </div>
        <div class="news-txt ny mg-t-b" style="height: auto;overflow: hidden;">

          <div style="width: 96%;height: auto;overflow: hidden">
            <div style="width: 100%;min-height: 40px;height: auto;overflow: hidden;line-height: 40px;">
              <div style="min-width:100px;height: 35px;line-height:30px;float: left;margin-left: 10px;margin-top: 5px;">
                <strong>项目所在地：</strong>

              </div>

              <div class="min-width:500px;min-height:40px;height:auto;overflow:hidden;">

                <div v-if="unitCode.indexOf('00000000')!=-1" class="perSelect" style="text-align: center;margin-top: 5px;padding: 0px;"
                  @click="getByCity(unitCode)" :class="{ activeSelectType: selectUnitCode == unitCode }">{{unitName}}</div>

                <div v-if="countys.length < 2" class="perSelect" style="text-align: center;margin-top: 5px;padding: 0px;"
                  @click="getCountys()">{{ unitName }}</div>

                <div v-for="(item, index) in countys" @click="getTowns(item.unitCode)" v-if="countys.length > 1"
                  class="perSelect" :class="{ activeSelectType: countyUnitCode == item.unitCode }"
                  style="margin-top: 5px;padding:0px !important">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div v-if="towns.length > 0"
              style="width: 100%;padding-left: 90px;height:auto;overflow: hidden;margin-top:5px;">
              <div style="min-width:100px;height: 30px;line-height:30px;float: left;margin-left: -80px;margin-top: 5px;">
                <strong>乡镇/街道：</strong>
              </div>
              <div v-for="(item, index) in towns" @click="getVillages(item.unitCode)" style="min-width: 70px"
                class="perSelect" :class="{ activeSelectType: townUnitCode == item.unitCode }">
                {{ item.name }}
              </div>
            </div>

            <!--村    <div v-if="villages.length>0" style="width: 100%;padding-left: 90px;;height:auto;overflow: hidden;">
                 <div  v-for="(item,index) in villages" @mouseover="getVillages(item.unitCode)" style="width: auto;float:left;cursor:pointer;min-width: 70px;height: 30px;line-height: 30px;">
                   {{item.na  me}}
                 </div>
            </div> -->

            <div style="width: 100%;height: 50px;line-height: 30px;">
              <div style="widt:100px;height: 30px;line-height:30px;float: left;margin-left: 10px;margin-top: 5px;">
                <strong>项目类别：</strong>
              </div>
              <div class="width:auto;">
                <div v-for="(item, index) in projectTypes" @click="getBySelectType(item.id)" class="perSelect"
                  :class="{ activeSelectType: selectType == item.id }">
                  {{ item.name }}
                </div>

              </div>
            </div>

            <div style="width: 100%;height: 45px;line-height: 30px;">
              <div style="widt:100px;height: 30px;line-height:30px;float: left;margin-left: 10px;margin-top: 5px;">
                <strong>项目状态：</strong>
              </div>
              <div class="width:auto;">
                <div v-for="(item, index) in projectStates" @click="getByState(item.id)" class="perSelect"
                  :class="{ activeSelectType: selectState == item.id }">
                  {{ item.name }}
                </div>

              </div>
            </div>



          </div>



          <div class="perTrade" @click=jump(trade.id) v-for="(trade, index) in trades">
            <div style="width:45%;height:180px;float:left;">
              <img v-if="trade.images != null" :src="trade.images.split(',')[0]"
                style="height: 94%;width: 100%;margin-top: 3%;" />
            </div>
            <div style="width:100%;height:40px;margin-top:0px;position: absolute;">
              <img v-if="trade.state == 5" src="../../../assets/trade/enrolling.png"
                style="width:60px;height:40px;margin-top: 15px;margin-left: 5px;" />
              <img v-if="trade.state == 10" src="../../../assets/trade/chengjiao.png"
                style="width:60px;height:25px;margin-top: 15px;margin-left: 5px;" />
            </div>
            <div style="width:52%;margin-left: 2%;float: left;">
              <div style="font-weight: 500;margin-top: 1px;max-height:60px">
                {{ trade.itemName }}
              </div>
              <div style="width: 100%;height: 30px;line-height: 30px;">项目编号：{{ trade.itemNum }}</div>
              <div style="width: 100%;height: 30px;line-height: 30px;">交易状态：
                <span v-if="trade.state == 5">已发布</span>
                <span v-if="trade.state == 6">已摘牌</span>
                <span v-if="trade.state == 7">竞价</span>
                <span v-if="trade.state == 8">竞价结束</span>
                <span v-if="trade.state == 9">终止转出</span>
                <span v-if="trade.state == 10">成交</span>
              </div>
              <div style="width: 100%;height: 30px;line-height: 30px;">交易类型：
                <span v-if="trade.tradeWay == 1">自由竞价</span>
                <span v-if="trade.tradeWay == 2">网络竞价（向上竞价）</span>
                <span v-if="trade.tradeWay == 3">拍卖</span>
                <span v-if="trade.tradeWay == 4">招投标</span>
                <span v-if="trade.tradeWay == 5">其他</span>
                <span v-if="trade.tradeWay == 6">招商</span>

              </div>

              <div style="width: 100%;height: 30px;line-height: 30px;">起始价格：
                <span style="color: #4cb050;font-weight: 500;">￥{{ trade.price }}
                 {{getEnumByCode(trade.priceType)}}
                </span>
              </div>

            </div>

          </div>



        </div>
        <div class="" style="width: 100%;height: 40px;text-align: center;">
          <div class="tabListPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
              :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      trades: [],
      pageNum: 1, // 默认显示第几页
      totalCount: 0, // 总条数，根据接口获取数据长度(注意：这里不能为空)
      pageSizes: [10, 15, 20], // 个数选择器（可修改）
      pageSize: 10, // 默认每页显示的条数（可修改）
      type: "",
      pathUrl: "",
      typeName: "",
      tradeType: "",
      unitCode: localStorage.getItem("unitCode"),
      unitName: localStorage.getItem("unitName"),
      countys: [],
      towns: [],
      villages: [],
      countyUnitCode: "",
      townUnitCode: "",
      villageUnitCode: "",
      selectUnitCode: localStorage.getItem("unitCode"),
      emnus:[],
      selectType: "",//类别查询
      selectAreaNum: "",//面积查询
      itemNum: "",//项目编号
      itemName: "",//项目名称
      selectState: 0,
      projectTypes: [
        { "id": "", "name": "全部" },
        { "id": 1, "name": "土地经营权" },
        { "id": 2, "name": "集体资产" },
        { "id": 3, "name": "集体建设地" },
        { "id": 4, "name": "涉农项目" },
        { "id": 5, "name": "股权" },
        // { "id": 6, "name": "宅基地" },
        { "id": 7, "name": "农民住房" },
        { "id": 8, "name": "养殖水面" },
        { "id": 9, "name": "林地林木" },
        { "id": 10, "name": "设施设备" },
        { "id": 14, "name": "资产处置" },
      ],
      projectStates: [
        { "id": "", "name": "全部" },
        { "id": 1, "name": "交易中" },
        { "id": 2, "name": "已成交" },
        { "id": 3, "name": "未成交" },
        { "id": 4, "name": "交易终止" },
      ]

    }
  },
  mounted() {
    this.countyUnitCode = localStorage.getItem("unitCode");
    if (this.unitCode.indexOf("00000000") != -1) {
      this.getCountys();

    }
    else {
      this.getTowns(this.unitCode);

    }

    if (this.$route.query.itemName != null && this.$route.query.itemName != "") {
      this.itemName = this.$route.query.itemName;
    }

    this.getDatas();
    this.getEmnusByType(2);
      },
      methods: {
        async getEmnusByType(type){
          const action = "/web/queryEnumsByType/"+type;
          const {
            data: res
          } = await this.$http.get(action);
          this.emnus=res.data;
        },
         getEnumByCode(code){
          return this.emnus.find(d => d.code === code).desc;
        },
    getByCity(unitCode){
      this.selectUnitCode=unitCode;
      this.countyUnitCode="";
      this.towns=[];
      this.getDatas();
    },
    async getDatas() {
      const action = "/web/v1/transferList?state=" + this.selectState + "&pageNum=" + this.pageNum + "&pageSize=" + this.pageSize +
        "&typeList=" + this.selectType + "&unitCode=" + this.selectUnitCode + "&areaNum=" + this.selectAreaNum + "&itemNum=" + this.itemNum + "&itemName=" + this.itemName;
      const {
        data: res
      } = await this.$http.get(action);
      this.trades = res.data.content;
      this.totalCount = res.data.totalElements;

    },
    getBySelectType(type) {
      this.selectType = type;
      this.getDatas();
    },
    getByState(type) {
      this.selectState = type;
      this.getDatas();
    },
    async getCountys() {
      this.selectUnitCode = this.unitCode;

      this.getDatas();
      const action = "/web/unitCode/getXians/" + this.unitCode;
      const {
        data: res
      } = await this.$http.get(action);
      this.countys = res.data;

    },
    async getTowns(countyUnitCode) {
      this.countyUnitCode = countyUnitCode;
      const action = "/web/unitCode/getXiangs/" + countyUnitCode;
      const {
        data: res
      } = await this.$http.get(action);
      this.selectUnitCode = countyUnitCode;
      this.towns = res.data;
      this.getDatas();
    },

    async getVillages(unitCode) {
      this.selectUnitCode = unitCode;
      this.townUnitCode = unitCode;
      this.getDatas();
      // const action = "/web/unitCode/getCuns/" + unitCode;
      // const {
      // 	data: res
      // } = await this.$http.get(action);
      // this.villages = res.data;
    },
    selectVillageUnitCode() {
      this.selectUnitCode = this.villageUnitCode;
      this.getDatas();

    },
    handleSizeChange(val) { // 每页显示的条数，选择每页条数的时候执行
      console.log("handleSizeChange")
      this.pageSize = val // 改变每页显示的条数
      this.getDatas() // 点击每页显示的条数时，显示第一页
      //this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
    },
    // 显示第几页
    handleCurrentChange(val) {
      this.pageNum = val; // 改变默认的页数
      this.getDatas() // 切换页码时，要获取每页显示的条数
    },
    handleClose(done) {
      done();
    },
    jump(ids) {
      this.$router.push({
        name: 'transferDetail',
        query: {
          id: ids
        }
      })
    },
  }


};
</script>

<style>
@import url("../../../assets/css/index.css");
@import url("../../../assets/css/base.css");
@import url("../../../assets/css/main.css");
@import url("../../../assets/css/news.css");

.perSelect {
  width: auto;
  float: left;
  cursor: pointer;
  margin-left: 5px;
  min-width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  padding: 2px;
  margin-top: 5px;
}

.perSelect:hover {
  background-color: #4cb050;
  border-radius: 2px;

}

.perTrade {
  width: 46%;
  height: 180px;
  float: left;
  border: 1px solid #cccccc4f;
  margin-left: 2%;
  margin-top: 10px;
  cursor: pointer;
}

.perTrade:hover {
  border: 1px solid #4cb050;
}

a {
  color: black;
}

.navTitle {
  border-bottom: 1px solid #f6f6f6;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 200px;
  background-color: #f6f6f6;
  font-size: 20px;

}

.activeSelectType {
  background-color: #4cb050;
  border-radius: 2px;

  color: white;

}

.per {
  width: 98%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #9796a72e;
  cursor: pointer;
}

.typeNav {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  border-bottom: 1px solid #f6f6f6;
}

.searchPer_right select {
  width: 100%;
}

.hone-container {
  height: 100%;
}

a-layout-content {
  height: 100%;
}

.ant-layout-header {
  /* 2850A0 */
  padding: 0px;
  background-color: #3c8dbc !important;
}

.main {
  width: 1220px;
  margin: 0 auto;
  height: auto;
  overflow: hidden;
  background-color: white;
  margin-top: 5px;
  min-height: 800px;
}

.title {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background-color: #f6f6f6;
  margin-top: 15px;

}

.title_per {
  width: 25%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  font-size: 16px;
}

.title_perName {
  width: 35%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.title_perDate {
  width: 15%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  float: left;
  font-size: 16px;


}


.perContent:nth-child(odd) {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background-color: #f6f6f6;
  text-align: center;
}

.perContent:nth-child(even) {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background-color: #FFFFFF;
  text-align: center;
}

.searchPer {

  width: 25%;
  height: 40px;
  float: left;
  text-align: left;
  font-size: 16px;
}

.searchPer_left {
  width: 30%;
  text-align: right;
  height: 30px;
  float: left;
}

.searchPer_right {
  width: 70%;
  height: 30px;
  float: left;
}

.searchPer_right select {
  display: inline-block;

  border: solid 1px #eeeeee;
  width: 165px;
  margin-left: 6px;
  height: 30px;
}

.searchPer_right input {
  display: inline-block;

  border: solid 1px #eeeeee;
  width: 165px;
  margin-left: 6px;
  height: 30px;
}

.btn-search1 {
  background-color: #4cb050;
  color: #ffffff;
  display: inline-block;
  text-align: center;
  margin-left: 0px;
  height: 40px;
  width: 60px;
  cursor: pointer;
  border: 1px solid #4cb050;
}
</style>
